<template>
    <div class="inline-block">
        <submenu placement="top-start" dropdown-class="mb-md">
            <button class="btn" :class="getButtonHtmlClass(currentStatus)">
                <font-awesome-icon
                    v-if="selectedStatus.icon"
                    :icon="selectedStatus.icon"
                    class="mr-sm"
                />
                {{ selectedStatus.label }}
            </button>

            <template slot="dropdown">
                <button
                    v-for="(status, key) in availableStatuses"
                    class="w-full text-left flex items-center p-sm hover:bg-neutral-lightest"
                    :class="{ 'bg-neutral-lightest': currentStatus === key }"
                    @click="$emit('changed', status)"
                >
                    <div class="icon-circle is-sm mr-md" :class="`bg-${status.color} text-${status.contrast_color}`">
                        <font-awesome-icon v-if="status.icon" :icon="status.icon" />
                    </div>
                    {{ status.label }}
                </button>
            </template>
        </submenu>
    </div>
</template>

<script>
    export default {
        props: {
            availableStatuses: {
                type: Object,
                required: true,
            },
            currentStatus: {
                type: String,
                required: true,
            },
        },
        computed: {
            selectedStatus() {
                return this.availableStatuses[this.currentStatus];
            },
        },
        methods: {
            getHtmlClass(status) {
                return [
                    status.color ? `bg-${status.color}` : null,
                    status.contrast_color ? `text-${status.contrast_color}` : null,
                ];
            },
            getButtonHtmlClass(status) {
                return [
                    `bg-${this.selectedStatus.color}`,
                    `text-${this.selectedStatus.contrast_color}`,
                    this.selectedStatus.key === 'created'
                        ? 'border border-black'
                        : `border border-${this.selectedStatus.color}`,
                ];
            },
        },
    };
</script>